<template>
  <div id="load_portal" class="portal_loading" style="display:none;">
    <div class="load-wrap">
      <div class="header_line">
        <div class="header_line_1" />
        <div class="header_line_2" />
        <div class="header_line_3" />
        <div class="header_line_3" />
      </div>
      <div class="banner_box" />
      <div class="banner_line" />
      <div class="tab_list">
        <div v-for="i in 5" :key="i" class="tab_item">
          <div class="tab_item_icon" />
          <div class="tab_item_text" />
        </div>
      </div>
      <div class="tab_line" />
      <div class="content">
        <div v-for="i in 4" :key="i" class="content_item">
          <div class="title_line">
            <div class="left_title">
              <div class="icon" />
              <div class="label" />
            </div>
            <div class="right_icon">
              <div class="icon" />
              <div class="icon" />
            </div>
          </div>
          <div class="card_list">
            <div v-for="j in 5" :key="j" :class="i === 1 ? 'card_item0' : 'card_item'" />
          </div>
        </div>
      </div>

    </div>
    <div class="bottom_tab" />
  </div>
</template>
<script>
export default {
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
@keyframes rotateAnimation {
  0% {
    // transform: rotate(0deg);
    opacity: 0.2;
  }
  50% {
    // transform: rotate(360deg);
    opacity: 0.3;
  }
  100% {
    // transform: rotate(360deg);
    opacity: 0.2;
  }
}
.portal_loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: var(--home-bg);
  // url(~@/assets/portal/home/bg@2x.webp);
  background-repeat: no-repeat;
  background-size: 100% auto;
  background-position: top center;
  z-index: 999999;
  padding-left:24px;
  .load-wrap{
    // position: relative;
    width: 100%;
    height: calc(100% - 176px);
    overflow: auto;
  }
}
.header_line {
  height: 88px;
  width:702px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header_line_1 {
    height: 64px;
    width: 218px;
    border-radius: 8px;
    background-image: linear-gradient(-76deg, #A19CBB 0%, #686385 100%);
    animation: rotateAnimation 2s linear infinite;
}
.header_line_2 {
  height: 64px;
    width: 288px;
    border-radius: 200px;
    background-image: linear-gradient(-76deg, #A19CBB 0%, #686385 100%);
    animation: rotateAnimation 2s linear infinite;
}
.header_line_3 {
  height: 64px;
    width: 64px;
    border-radius: 200px;
    background-image: linear-gradient(-76deg, #A19CBB 0%, #686385 100%);
    animation: rotateAnimation 2s linear infinite;
}
.banner_box {
    margin-top:16px;
    height: 124px;
    width: 702px;
    border-radius: 20px;
    background-image: linear-gradient(-76deg, #A19CBB 0%, #686385 100%);
    animation: rotateAnimation 2s linear infinite;
}
.banner_line {
    margin-top:16px;
    margin-left:200px;
  height: 10px;
    width: 300px;
    border-radius: 5px;
    background-image: linear-gradient(-76deg, #A19CBB 0%, #686385 100%);
    animation: rotateAnimation 2s linear infinite;
}
.tab_list {
  display: flex;
  justify-content: space-between;
  margin-top:32px;
  width: 702px;
}
.tab_item {
  display: flex;
  flex-direction: column;
  padding:0 18px;
}
.tab_item_icon {
  height: 72px;
    width: 72px;
    margin-left:12px;
    border-radius: 20px;
    background-image: linear-gradient(-76deg, #A19CBB 0%, #686385 100%);
    animation: rotateAnimation 2s linear infinite;
}
.tab_item_text {
  height: 24px;
    width: 96px;
    border-radius: 8px;
    background-image: linear-gradient(-76deg, #A19CBB 0%, #686385 100%);
    animation: rotateAnimation 2s linear infinite;
    margin-top:12px;
}
.tab_line{
    margin-top:32px;
    height: 64px;
    width: 702px;
    border-radius: 200px;
    background-image: linear-gradient(-76deg, #A19CBB 0%, #686385 100%);
    animation: rotateAnimation 2s linear infinite;
}
.content {

}
.content_item {
  margin-top:32px;
}
.title_line {
  display: flex;
  justify-content: space-between;
  width: 710px;
}
.left_title {
  display: flex;
}
.left_title .icon {
  height: 40px;
    width: 40px;
    border-radius: 8px;
    background-image: linear-gradient(-76deg, #A19CBB 0%, #686385 100%);
    animation: rotateAnimation 2s linear infinite;
}
.left_title .label {
    margin-left: 16px;
    height: 40px;
    width: 64px;
    border-radius: 8px;
    background-image: linear-gradient(-76deg, #A19CBB 0%, #686385 100%);
    animation: rotateAnimation 2s linear infinite;
}
.right_icon {
    display: flex;
}
.right_icon .icon {
  height: 40px;
    width: 40px;
    border-radius: 8px;
    background-image: linear-gradient(-76deg, #A19CBB 0%, #686385 100%);
    animation: rotateAnimation 2s linear infinite;
    margin:8px;
}
.card_list {
  width: 726px;
  overflow: hidden;
  display: flex;

}
.card_item0 {
   height: 208px;
    min-width: 156px;
    border-radius: 14px;
    background-image: linear-gradient(-76deg, #A19CBB 0%, #686385 100%);
    animation: rotateAnimation 2s linear infinite;
    margin-right:16px;
}
.card_item {
   height: 208px;
    min-width: 212px;
    border-radius: 14px;
    background-image: linear-gradient(-76deg, #A19CBB 0%, #686385 100%);
    animation: rotateAnimation 2s linear infinite;
    margin-right:16px;
}
.bottom_tab{
    margin-top:24px;
    width: 702px;
    height:112px;
    border-radius: 200px;
    background-image: linear-gradient(-76deg, #A19CBB 0%, #686385 100%);
    animation: rotateAnimation 2s linear infinite;
}
</style>
